import PropTypes from 'prop-types'
import { Button } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'
import FixedBottomWrapper from '../../components/FixedBottomWrapper'
import Snackbar from '../../../ui/components/Snackbar'
import SuccessfulShipmentModal from '../../../context/ShippingSend/SuccessfulShipmentModal'

const FormActions = ({
  showSubmitButton,
  onCancelProcess,
  formErrors,
  onSubmit,
  snackbarBottomPosition,
  showSendError,
  showCancelConfirmation,
  setShowCancelConfirmation,
  isSubmitting,
  newShippingCode,
  goToHome,
  requestAnotherShipping,
}) => {
  const t = useTranslations()
  const successfullShipment = Boolean(newShippingCode)

  return (
    <>
      {showSendError && (
        <Snackbar
          severity="error"
          text={t(formErrors[0])}
          open={true}
          bottomPosition={snackbarBottomPosition}
          fixed
        />
      )}
      {showCancelConfirmation && (
        <Snackbar
          severity="warning"
          title={t('shipping-send:cancel:title')}
          text={t('shipping-send:cancel:description')}
          open={true}
          bottomPosition={snackbarBottomPosition}
          fixed
        />
      )}
      {successfullShipment ? (
        <SuccessfulShipmentModal
          isOpen
          shippingCode={newShippingCode}
          onCloseClick={goToHome}
        />
      ) : null}
      <FixedBottomWrapper fullWidth zIndexModal>
        <>
          {showCancelConfirmation ? (
            <Button
              fullWidth
              type="button"
              onClick={onCancelProcess}
              variant={showSubmitButton ? 'outlined' : 'contained'}
              disabled={isSubmitting}
            >
              {t('shipping-send-form:action:confirm-cancellation')}
            </Button>
          ) : !successfullShipment ? (
            <Button
              fullWidth
              type="button"
              variant={showSubmitButton ? 'outlined' : 'contained'}
              onClick={() =>
                showSendError
                  ? onCancelProcess()
                  : setShowCancelConfirmation(true)
              }
              disabled={isSubmitting}
            >
              {t('shipping-send-form:action:cancel-my-request')}
            </Button>
          ) : null}
          {showSubmitButton ? (
            <Button
              fullWidth
              // onClick={() => {
              //   // TODO: (dev): Al finalizar la solicitud, no debe llevar a la Home automáticamente (lo que hace ahora)
              //   // onSubmit
              //   // setSuccessfullShipment(true)
              // }}
              onClick={successfullShipment ? requestAnotherShipping : onSubmit}
            >
              {successfullShipment
                ? t('action:new-shipping')
                : t('shipping-send-form:action:process-shipment')}
            </Button>
          ) : null}
        </>
      </FixedBottomWrapper>
    </>
  )
}

FormActions.propTypes = {
  showSubmitButton: PropTypes.bool,
  onCancelProcess: PropTypes.func,
  formErrors: PropTypes.arrayOf(PropTypes.string),
  onSubmit: PropTypes.func,
  snackbarBottomPosition: PropTypes.number,
  showSendError: PropTypes.bool,
  showCancelConfirmation: PropTypes.bool,
  setShowCancelConfirmation: PropTypes.func,
  isSubmitting: PropTypes.bool,
  newShippingCode: PropTypes.string,
}

export default FormActions
